import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { resetPassword } from 'store/actions/resetPassword';
import { fetchReset } from 'store/actions/entities';
import Stage3 from 'components/ResetPasswordStages/Stage3/index';

export default withTranslation()(connect(null, { resetPassword, fetchReset })(Stage3));
